import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78c7d45a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "gennera-banner-shell"
}
const _hoisted_2 = { class: "gennera-banner-track" }
const _hoisted_3 = ["aria-hidden"]
const _hoisted_4 = ["href", "target", "rel", "aria-label"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "gennera-banner-logo",
  src: "https://apps.gennera.com.br/admin/img/logo_header.png",
  alt: "Gennera"
}, null, -1))
const _hoisted_6 = { class: "gennera-banner-copy" }
const _hoisted_7 = {
  key: 0,
  class: "gennera-banner-title"
}
const _hoisted_8 = {
  key: 1,
  class: "gennera-banner-highlight"
}
const _hoisted_9 = {
  key: 2,
  class: "gennera-banner-subtitle"
}
const _hoisted_10 = {
  key: 3,
  class: "gennera-banner-action"
}
const _hoisted_11 = {
  key: 4,
  class: "gennera-banner-accent",
  "aria-hidden": "true"
}
const _hoisted_12 = ["aria-label"]
const _hoisted_13 = ["aria-label", "aria-pressed", "onClick"]

import { computed, onMounted, onUnmounted, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    banners: { type: Array, required: true }
  },
  setup(__props: any) {

const props = __props as { banners: Array<any> }

const currentBannerIndex = ref(0);
let rotation: number | undefined;

const normalizeUrl = function (url: any) {
	if (!url || !String(url).trim()) return undefined;
	const value = String(url).trim();
	if (/^\/\//.test(value)) return "https:" + value;
	if (/^https?:\/\//i.test(value) || /^mailto:/i.test(value) || value.charAt(0) === "/") return value;
	return "https://" + value;
};

const activeBanners = computed(() => (props.banners || []).map(function (source) {
	const data = { ...(source.data || {}) };
	data.content = { ...(data.content || {}) };
	data.content.layout = data.content.layout || "cta";
	const image = source.imagem || data.background?.url;
	return {
		...source,
		data,
		hasEditableContent: Number(data.composerVersion) === 1,
		needsContrast: data.background?.contrast === "light",
		linkUrl: normalizeUrl(source.url),
		backgroundStyle: image ? { backgroundImage: `url("${String(image).replace(/\\/g, "\\\\").replace(/"/g, '\\"')}")` } : {}
	};
}));

const stopRotation = function () {
	if (rotation !== undefined) window.clearInterval(rotation);
	rotation = undefined;
};

const startRotation = function () {
	stopRotation();
	if (activeBanners.value.length < 2 || window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
	rotation = window.setInterval(function () {
		currentBannerIndex.value = (currentBannerIndex.value + 1) % activeBanners.value.length;
	}, 10000);
};

const selectBanner = function (index: number) {
	currentBannerIndex.value = index;
	startRotation();
};

watch(() => props.banners, function () {
	currentBannerIndex.value = 0;
	startRotation();
}, { deep: true });

onMounted(startRotation);
onUnmounted(stopRotation);

return (_ctx: any,_cache: any) => {
  return (_unref(activeBanners).length)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeBanners), (banner, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: banner.idProductBanner,
              class: _normalizeClass(["gennera-banner-slide", { active: index === currentBannerIndex.value }]),
              "aria-hidden": index !== currentBannerIndex.value
            }, [
              _createElementVNode("a", {
                class: _normalizeClass(["gennera-banner-content", ['layout-' + banner.data.content.layout, { 'needs-contrast': banner.needsContrast, 'has-link': banner.linkUrl }]]),
                href: banner.linkUrl,
                target: banner.linkUrl ? '_blank' : undefined,
                rel: banner.linkUrl ? 'noopener noreferrer' : undefined,
                "aria-label": banner.linkUrl ? _ctx.$t('Open banner in a new tab') + ': ' + (banner.title || _ctx.$t('Banner')) : (banner.title || _ctx.$t('Banner'))
              }, [
                _createElementVNode("span", {
                  class: "gennera-banner-image",
                  style: _normalizeStyle(banner.backgroundStyle)
                }, null, 4),
                (banner.hasEditableContent)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["gennera-banner-composition", ['layout-' + banner.data.content.layout, 'template-' + banner.data.content.template]])
                    }, [
                      _hoisted_5,
                      _createElementVNode("span", _hoisted_6, [
                        (banner.title)
                          ? (_openBlock(), _createElementBlock("strong", _hoisted_7, _toDisplayString(banner.title), 1))
                          : _createCommentVNode("", true),
                        (banner.data.content.highlight)
                          ? (_openBlock(), _createElementBlock("strong", _hoisted_8, _toDisplayString(banner.data.content.highlight), 1))
                          : _createCommentVNode("", true),
                        (banner.data.content.subtitle)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(banner.data.content.subtitle), 1))
                          : _createCommentVNode("", true),
                        (banner.data.content.layout === 'cta' && banner.data.content.actionLabel)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(banner.data.content.actionLabel), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_11))
                      ])
                    ], 2))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_4)
            ], 10, _hoisted_3))
          }), 128))
        ]),
        (_unref(activeBanners).length > 1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "gennera-banner-indicators",
              role: "group",
              "aria-label": _ctx.$t('Select banner')
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeBanners), (_, index) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: index,
                  type: "button",
                  class: _normalizeClass({ active: index === currentBannerIndex.value }),
                  "aria-label": _ctx.$t('Show banner') + ' ' + (index + 1),
                  "aria-pressed": index === currentBannerIndex.value,
                  onClick: ($event: any) => (selectBanner(index))
                }, null, 10, _hoisted_13))
              }), 128))
            ], 8, _hoisted_12))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})